import { render, staticRenderFns } from "./AddEditIndividualWork.vue?vue&type=template&id=ca81ea64"
import script from "./AddEditIndividualWork.vue?vue&type=script&lang=js"
export * from "./AddEditIndividualWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports